// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentSummaryViewHeading_container__5Klmd","title":"PaymentSummaryViewHeading_title__ifiXT"};